var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.node.type
    ? _c(
        "div",
        [
          _c(_vm.componentName, {
            tag: "component",
            attrs: { nid: parseInt(_vm.node.nid) },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }